// extracted by mini-css-extract-plugin
export default {"short-list":"Shortlist_short-list__6EeeC","create-job":"Shortlist_create-job__NCxRd"};